// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-report-observation-periods__chart{margin-top:2rem}.ac-report-observation-periods__summary-row{display:flex}.ac-report-observation-periods__summary-col{border-bottom:1px solid #F6F6F6;flex-basis:50%;padding:1.5rem;text-align:right}.ac-report-observation-periods__summary-col--title{font-family:\"Montserrat\";text-transform:uppercase;text-align:left}\n", ""]);
// Exports
module.exports = exports;
